// extracted by mini-css-extract-plugin
export default {"Box":"iterations-header-module__Box--pil1q","Octicon":"iterations-header-module__Octicon--lTxDy","Box_1":"iterations-header-module__Box_1--YW3of"};